import { createUnityBridgeCommands, sendBridgeMessage, UNITY_BRIDGE_GO, UNITY_BRIDGE_METHODS, safeSendBridgeMessage } from "./unityBridge";

let bridgeCommands = null;
let sendMessageRef = null;
const methodMap = {
    master: UNITY_BRIDGE_METHODS.SET_MASTER_VOLUME,
    music: UNITY_BRIDGE_METHODS.SET_MUSIC_VOLUME,
    sfx: UNITY_BRIDGE_METHODS.SET_SFX_VOLUME,
  };
function attachDevConsoleBridge() {
  if (process.env.NODE_ENV !== "development" || typeof window === "undefined") return;

  window.__nqUnity = {
    send(method, data) {
      if (!sendMessageRef) {
        console.warn("[__nqUnity] Unity not loaded yet — wait for the city to appear.");
        return null;
      }
      return sendBridgeMessage(sendMessageRef, method, data);
    },
    cmds() {
      return bridgeCommands;
    },
    goToRoom(roomId) {
      return bridgeCommands?.goToRoom(roomId);
    },
    showPopup(id) {
      if (typeof window.__nqShowPopup === "function") return window.__nqShowPopup(id);
      console.warn("[__nqUnity] showPopup handler not registered yet");
      return false;
    },
    gameObject: UNITY_BRIDGE_GO,
  };
}

function detachDevConsoleBridge() {
  if (typeof window !== "undefined") {
    delete window.__nqUnity;
  }
}

/** Register react-unity-webgl sendMessage when Unity loads (cleared on unmount). */
export function registerUnitySendMessage(sendMessage) {
  sendMessageRef = sendMessage ?? null;
  bridgeCommands = createUnityBridgeCommands(sendMessage);
  if (sendMessage) {
    attachDevConsoleBridge();
  } else {
    detachDevConsoleBridge();
  }
}

export function getUnityBridgeCommands() {
  return bridgeCommands;
}


function formatVolume(value) {
  const volumeForamtedValue = Math.min(1, Math.max(0, Number(value) || 0));
  return String(parseFloat(volumeForamtedValue.toFixed(3)));
}

export function setUnityVolume(channel, value) {
  
  const method = methodMap[channel];
  if (!method || !sendMessageRef) return;
  try {
    sendBridgeMessage(sendMessageRef, method, formatVolume(value));
  } catch {
    console.warn("[NeuroQuest → Unity] setUnityVolume failed — Unity not loaded yet");
  }
}

export function setUnityMuted(channel, muted) {
  const methodMap = {
    master: UNITY_BRIDGE_METHODS.SET_MASTER_MUTED,
    music: UNITY_BRIDGE_METHODS.SET_MUSIC_MUTED,
    sfx: UNITY_BRIDGE_METHODS.SET_SFX_MUTED,
  };
  const method = methodMap[channel];
  if (!method || !sendMessageRef) return;
  try {
    sendBridgeMessage(sendMessageRef, method, muted ? "true" : "false");
  } catch {
    console.warn("[NeuroQuest → Unity] setUnityMuted failed — Unity not loaded yet");
  }
}

/** Navigate Unity 3D camera/player to a room by world_json room id. */
export async function goToUnityRoom(roomId) {
  const id = roomId != null ? String(roomId).trim() : "";
  if (!id) return { ok: false, error: new Error("room id required") };
  if (!sendMessageRef) {
    if (process.env.NODE_ENV === "development") {
      console.warn("[NeuroQuest → Unity] GoToRoom skipped — Unity not loaded");
    }
    return { ok: false, error: new Error("Unity not loaded") };
  }
  return safeSendBridgeMessage(sendMessageRef, UNITY_BRIDGE_METHODS.GO_TO_ROOM, id, {
    attempts: 4,
    delayMs: 400,
    silent: true,
  });
}
